import React from 'react'
import { colorsPN } from '@news-mono/design-tokens'

const color = colorsPN.fill.base

export const IconVideoPlay: React.FC = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
    >
        <path
            d="M7 3L21 12L7 21V3Z"
            fill={color}
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
